import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/60 bg-accent-100/50 text-accent-900 text-xs font-medium mb-5">
              What Is This?
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-5 leading-tight">
              What Is the AllChinaBuy<br />Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              The <strong>AllChinaBuy Spreadsheet</strong> is a carefully curated collection of products, trusted sellers, and purchasing resources designed to help buyers find high-quality items efficiently. Instead of spending hours searching through countless individual stores, buyers can compare products, prices, quality levels, and shipping options all in one organized system.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Whether you are looking for the <strong>best allchinabuy spreadsheet</strong> for sneakers, clothing, or accessories, our curated resource gives you direct access to verified sellers with transparent ratings and real buyer feedback. Each entry includes seller ratings, price ranges, shipping estimates, and direct product links — everything you need to make informed purchasing decisions.
            </p>
            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Read the Full Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
            <div className="flex items-center gap-12 mt-10">
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">500+</p>
                <p className="text-xs text-foreground-500 mt-1">Verified Products</p>
              </div>
              <div>
                <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">50+</p>
                <p className="text-xs text-foreground-500 mt-1">Trusted Sellers</p>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20sleek%20tablet%20device%20on%20a%20light%20oak%20desk%20surface%20displaying%20an%20organized%20product%20catalog%20interface%20with%20clean%20grid%20layout%20warm%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20casting%20soft%20shadows%20a%20small%20potted%20succulent%20plant%20and%20ceramic%20mug%20nearby%20modern%20minimalist%20workspace%20editorial%20photography%20with%20airy%20and%20calm%20atmosphere&width=800&height=600&seq=what-is-v2-section&orientation=landscape"
                alt="AllChinaBuy Spreadsheet overview"
                title="AllChinaBuy Spreadsheet - trusted allchinabuy spreadsheet resource"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4">
                <span className="inline-block px-3 py-1 bg-background-50/90 text-foreground-900 text-xs font-medium rounded-full">
                  Updated Weekly
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <p className="text-background-50 text-sm font-medium">Your all-in-one shopping resource</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}